// SVG Flag Components

interface FlagProps {
  className?: string;
}

export const TurkeyFlag: React.FC<FlagProps> = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 36 24" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="36" height="24" fill="#E30A17"/>
    <circle cx="14" cy="12" r="5" fill="white"/>
    <circle cx="15.5" cy="12" r="4" fill="#E30A17"/>
    <path d="M 18 9 L 19.5 11.5 L 22.5 11.5 L 20 13.5 L 21 16 L 18 14 L 15 16 L 16 13.5 L 13.5 11.5 L 16.5 11.5 Z" fill="white"/>
  </svg>
);

export const USAFlag: React.FC<FlagProps> = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 36 24" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="36" height="24" fill="white"/>
    <rect width="36" height="1.85" fill="#B22234"/>
    <rect width="36" height="1.85" y="3.69" fill="#B22234"/>
    <rect width="36" height="1.85" y="7.38" fill="#B22234"/>
    <rect width="36" height="1.85" y="11.08" fill="#B22234"/>
    <rect width="36" height="1.85" y="14.77" fill="#B22234"/>
    <rect width="36" height="1.85" y="18.46" fill="#B22234"/>
    <rect width="36" height="1.85" y="22.15" fill="#B22234"/>
    <rect width="14.4" height="12.92" fill="#3C3B6E"/>
    <g fill="white">
      <circle cx="2" cy="2" r="0.5"/>
      <circle cx="4" cy="2" r="0.5"/>
      <circle cx="6" cy="2" r="0.5"/>
      <circle cx="8" cy="2" r="0.5"/>
      <circle cx="10" cy="2" r="0.5"/>
      <circle cx="12" cy="2" r="0.5"/>
      <circle cx="3" cy="3.5" r="0.5"/>
      <circle cx="5" cy="3.5" r="0.5"/>
      <circle cx="7" cy="3.5" r="0.5"/>
      <circle cx="9" cy="3.5" r="0.5"/>
      <circle cx="11" cy="3.5" r="0.5"/>
      <circle cx="2" cy="5" r="0.5"/>
      <circle cx="4" cy="5" r="0.5"/>
      <circle cx="6" cy="5" r="0.5"/>
      <circle cx="8" cy="5" r="0.5"/>
      <circle cx="10" cy="5" r="0.5"/>
      <circle cx="12" cy="5" r="0.5"/>
      <circle cx="3" cy="6.5" r="0.5"/>
      <circle cx="5" cy="6.5" r="0.5"/>
      <circle cx="7" cy="6.5" r="0.5"/>
      <circle cx="9" cy="6.5" r="0.5"/>
      <circle cx="11" cy="6.5" r="0.5"/>
      <circle cx="2" cy="8" r="0.5"/>
      <circle cx="4" cy="8" r="0.5"/>
      <circle cx="6" cy="8" r="0.5"/>
      <circle cx="8" cy="8" r="0.5"/>
      <circle cx="10" cy="8" r="0.5"/>
      <circle cx="12" cy="8" r="0.5"/>
      <circle cx="3" cy="9.5" r="0.5"/>
      <circle cx="5" cy="9.5" r="0.5"/>
      <circle cx="7" cy="9.5" r="0.5"/>
      <circle cx="9" cy="9.5" r="0.5"/>
      <circle cx="11" cy="9.5" r="0.5"/>
      <circle cx="2" cy="11" r="0.5"/>
      <circle cx="4" cy="11" r="0.5"/>
      <circle cx="6" cy="11" r="0.5"/>
      <circle cx="8" cy="11" r="0.5"/>
      <circle cx="10" cy="11" r="0.5"/>
      <circle cx="12" cy="11" r="0.5"/>
    </g>
  </svg>
);

